export function getAuthor(entry, timelineElement) {
    $.ajax({
        type: "POST",
        url: "/module/community/ajax.php?action=get_author",
        datatype: "json",
        data: {"ajax_call_author_id": entry.author},
        success: function (output) {
            var container = $('.timeline_entry#' + timelineElement.id);
            var imageContainer = container.find(".js-post-author-image");
            if (output !== "false") {
                var author = $.parseJSON(output);
                container.find(".js-post-author-name").text(author.name+" ");
                imageContainer.find("img").attr("src", "/userdata/stammtisch/author_images/" + author.image);
                container.find(".js-post-author-link").attr("data-id", author.id);
            } else {
                imageContainer.find("img").attr("src", "/layout/frontend/stiegl/dist/images/no-profile-pic.png");
            }
        }
    });
}